var _excluded = ["ariaLabelledby", "children", "id", "isSelected"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
var Panel = _ref => {
  var {
      ariaLabelledby,
      children,
      id,
      isSelected
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    "aria-labelledby": ariaLabelledby,
    hidden: !isSelected,
    id: id,
    role: "tabpanel"
  }, otherProps), children);
};
Panel.propTypes = {
  /** Value for ARIA labelledby attribute generated by Tabpanel */
  ariaLabelledby: PropTypes.string.isRequired,
  /** Children to be rendered within the panel */
  children: PropTypes.node.isRequired,
  /** Unique id attribute generated by Tabpanel */
  id: PropTypes.string.isRequired,
  /** Whether to render in a selected state, generated by Tabpanel */
  isSelected: PropTypes.bool
};
Panel.defaultProps = {
  isSelected: false
};

// prevent required proptype errors
export default (props => /*#__PURE__*/React.createElement(Panel, props));